import {useEffect, useState} from "react";
import VLFModal from "@/components/Modal";
import VLFTextField from "@/components/Input/TextField";
import VoiceInput from "@/components/VoiceInput";

const general = [
	["minutes", "Minuti"],
	["rating", "Voto (1-10)"],
	["goals", "Gol fatti"],
	["assists", "Assist"],
	["yellowCards", "Cartellini gialli"],
	["redCard", "Espulsioni"],
];
const movement = [
	["keyPasses", "Passaggi chiave"],
	["duelsWon", "Duelli vinti"],
	["duelsTotal", "Duelli totali"],
	["interceptions", "Intercetti"],
	["recoveries", "Recuperi"],
	["totalShots", "Tiri totali"],
	["shotsOnTarget", "Tiri in porta"],
	["dribblesAttempted", "Dribbling tentati"],
	["dribblesSuccessful", "Dribbling riusciti"],
	["crossesAttempted", "Cross tentati"],
	["crossesCompleted", "Cross riusciti"],
];
const keeper = [
	["goalsConceded", "Gol subiti"],
	["saves", "Parate"],
	["outOfAreaReadings", "Letture fuori area"],
	["lowReadings", "Letture area basse"],
	["highReadings", "Letture area alte"],
	["shortHorizontalPassRight", "Pass. corti orizz. dx"],
	["shortHorizontalPassLeft", "Pass. corti orizz. sx"],
	["shortVerticalPass", "Pass. corti verticali"],
	["killerPass", "Killer pass"],
	["longFrontalPass", "Pass. lunghi frontali"],
	["longPassRight", "Pass. lunghi dx"],
	["longPassLeft", "Pass. lunghi sx"],
];

export default function HandleStatModal({open, initialData, confirm, close}) {
	const [values, setValues] = useState({});
	const [changed, setChanged] = useState({});
	useEffect(() => {
		setValues(initialData?.values || {});
		setChanged({});
	}, [initialData]);
	const fields = [...general, ...(initialData?.goalkeeper ? keeper : movement)];
	const change = (key, value) => {
		setValues((previous) => ({...previous, [key]: value}));
		setChanged((previous) => ({...previous, [key]: value}));
	};
	return (
		<VLFModal
			maxWidth="lg"
			open={open}
			title={"Statistiche · " + (initialData?.playerName || "")}
			close={close}
			disabled={!Object.keys(changed).length}
			confirm={() =>
				confirm({
					participationId: initialData.participationId,
					values: Object.fromEntries(
						Object.entries(changed).map(([key, value]) => [
							key,
							value === ""
								? null
								: ["strengths", "improvements"].includes(key)
									? value
									: Number(value),
						]),
					),
				})
			}
			content={
				<>
					<p>
						I valori dagli eventi si aggiornano dalla cronologia. I campi vuoti
						indicano dati non raccolti.
					</p>
					{initialData?.warning && (
						<p className="text-warning">{initialData.warning}</p>
					)}
					<div className="row">
						{fields.map(([key, label]) => (
							<div className="col-12 col-sm-6 col-lg-3" key={key}>
								<VLFTextField
									name={key}
									label={label}
									size="small"
									type="number"
									value={values[key] ?? ""}
									readOnly={["events", "conflict"].includes(
										initialData?.metrics?.[key]?.source,
									)}
									helperText={
										initialData?.metrics?.[key]?.source === "events"
											? "Dalla cronaca"
											: initialData?.metrics?.[key]?.conflict
												? "Il dato in cronaca è diverso: controlla prima di modificare"
												: ""
									}
									inputProps={{
										min: key === "rating" ? 1 : 0,
										max: key === "rating" ? 10 : undefined,
										step: key === "rating" ? 0.1 : 1,
									}}
									onChange={(event) => change(key, event.target.value)}
								/>
							</div>
						))}
					</div>
					<div className="row">
						{[
							["strengths", "Punti di forza"],
							["improvements", "Aree di miglioramento"],
						].map(([key, label]) => (
							<div className="col-12 col-lg-6" key={key}>
								<VoiceInput
									value={values[key] || ""}
									onChange={(value) => change(key, value)}
									label={label}
									placeholder="Scrivi o parla..."
									rows={2}
								/>
							</div>
						))}
					</div>
				</>
			}
		/>
	);
}
